import Loading from '../../components/Loading';

import CheckData from '../../components/CatchError';
import DataTable from '../../components/Datatable';
import Component from '../../components/Component';
import { COLUMNS } from './keys';
import query from './query';
import { scrollForTable } from '../../components/Datatable/utils';
import { withTranslation } from 'react-i18next';

class Summary extends Component {
    constructor() {
        super();
        this.searchFunction = this.searchFunction.bind(this);
        this.query = query;
    }

    searchFunction(data, search) {
        if (!search) return data;
        return data.filter((item) => item.appearance?.toLowerCase().includes(search.toLowerCase()));
    }

    render() {
        const { t } = this.props;

        if (this.state.loading && !this.state.loadMore) {
            return <Loading padding={10} />;
        }

        const sortFns = {
            appearance: (array) => array.sort((a, b) => a.appearance.localeCompare(b.appearance)),
            sumImpressions: (array) => array.sort((a, b) => a.sumImpressions - b.sumImpressions),
            sumClicks: (array) => array.sort((a, b) => a.sumClicks - b.sumClicks),
            avgCTR: (array) => array.sort((a, b) => a.avgCTR - b.avgCTR),
        };

        return (
            <>
                <CheckData
                    content_id={this.props.content_id}
                    parent_id={this.props.parent_id}
                    data={this.state.data}
                    loading={this.state.loading}
                >
                    <DataTable
                        nodes={this.state.data}
                        sortFns={sortFns}
                        COLUMNS={COLUMNS(t)}
                        uniqKey={'appearance'}
                        fileName={t('discover.appearances.table.header')}
                        header={t('discover.appearances.table.header')}
                        forceRun={this.forceRun}
                        customEmptyMessage={t('global.no_data')}
                        searchFunction={this.searchFunction}
                        additionalStyles={{
                            Table: `
                                --data-table-library_grid-template-columns :  minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) !important;
                                ${scrollForTable}
                            `,
                            BaseCell: `  font-family: 'Raleway';
                                        font-weight: 500;
                                        font-size: 16px;
                                        line-height: 19px;
                                        padding: 16px 10px !important;
                                        color: #0D182C;
                                    
                                    
                                        &.underline {
                                            text-decoration: underline;
                                        }
                                        `,
                        }}
                    />
                </CheckData>
            </>
        );
    }
}

export default withTranslation()(Summary);
